module.exports = __webpack_public_path__ + "video/B-A-005_SAF_BTB_PhysicalSecurity.ece1694a.vtt";